import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import AvatarGroupStacked from '../shared/AvatarGroupStacked';

function formatRelativeDate(dateString, t) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return t('Today');
  if (diffDays === 1) return t('1 day ago');
  if (diffDays < 30) return t('{{count}} days ago', { count: diffDays });
  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths === 1) return t('1 month ago');
  if (diffMonths < 12) return t('{{count}} months ago', { count: diffMonths });
  const diffYears = Math.floor(diffDays / 365);
  if (diffYears === 1) return t('1 year ago');
  return t('{{count}} years ago', { count: diffYears });
}

function InsightsDashboards(props) {
  const { dashboards = [], loading = false, fetchUserDashboards, t } = props;
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserDashboards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!loading && dashboards.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Typography variant="body1" color="text.secondary">
          {t('No dashboards available.')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Insights
      </Typography>
      <Grid container spacing={2}>
        {dashboards.map(dashboard => (
          <Grid item xs={12} sm={6} md={4} key={dashboard.dashboard_id}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardActionArea
                sx={{ height: '100%' }}
                onClick={() => navigate(`/insights/dashboards/${dashboard.dashboard_id}`)}>
                <CardContent>
                  <Typography variant="h6" fontWeight={600} gutterBottom noWrap>
                    {dashboard.title}
                  </Typography>
                  {dashboard.description && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mb: 2,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}>
                      {dashboard.description}
                    </Typography>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mt: 'auto',
                    }}>
                    <Typography variant="caption" color="text.secondary">
                      {formatRelativeDate(dashboard.created_at, t)}
                    </Typography>
                    <AvatarGroupStacked users={dashboard.users || []} maxVisible={4} />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default withTranslation()(InsightsDashboards);
